import { ContextAiNotice } from './ContextAiNotice';
import { ContextField } from './fields/ContextField';

import { useAmelioTranslations } from '@/hooks';

interface ContextStepProps {
    context: string;
    errorMessage?: string;
    onContextChange: (context: string) => void;
}

/**
 * Last step of the new-meeting window: the context the AI writes the agenda from. It is optional —
 * the footer creates the meeting whether or not anything was typed — so the step carries no way out
 * of its own.
 */
export const ContextStep = ({ context, errorMessage, onContextChange }: ContextStepProps) => {
    const { t } = useAmelioTranslations();

    return (
        <>
            <ContextAiNotice />

            <ContextField
                value={context}
                errorMessage={errorMessage}
                helpText={t('thematicMeetings.newMeeting.contextHelpAi')}
                onChange={onContextChange}
            />
        </>
    );
};
